import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { CustomerConfigService, ICustomerConfig } from '../services/customer-config.service';

@Injectable({ providedIn: 'root' })
export class CustomerConfigGuard implements CanActivate {
  constructor(
    private router: Router,
    private customerConfig: CustomerConfigService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const flag = route.data['customerConfigFlag'] as keyof ICustomerConfig;

    return this.customerConfig.refresh().pipe(
      catchError(() => of(this.customerConfig.config)),
      map((config) => {
        if (!flag || config?.[flag]) {
          return true;
        }

        const parentPath = (route.parent?.pathFromRoot ?? []).reduce(
          (path, r) => path.concat(r.url.map((segment) => segment.path)),
          <string[]>[],
        );
        return this.router.createUrlTree(['/', ...parentPath]);
      }),
    );
  }
}
